import { useLang } from "@/context/LanguageContext";
import { ASSETS } from "@/i18n";
import { Reveal } from "@/components/Reveal";
import { Check } from "lucide-react";

export const DashboardPreview = () => {
  const { t } = useLang();
  return (
    <section
      id="dashboard"
      data-testid="dashboard-section"
      className="relative py-24 md:py-32 overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, #FAFAFA 0%, #F5F0FF 40%, #FFF5F5 100%)",
      }}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <Reveal className="lg:col-span-5">
          <div className="text-[11px] tracking-[0.3em] uppercase text-[#A78BFA] mb-5" data-testid="dashboard-eyebrow">
            {t.dashboard.eyebrow}
          </div>
          <h2
            data-testid="dashboard-title"
            className="font-serif font-light text-4xl md:text-5xl leading-[1.05] tracking-tight text-[#1A1A1A]"
          >
            {t.dashboard.title}
          </h2>
          <p className="mt-6 text-base md:text-lg text-[#4A4A4A] leading-relaxed font-light" data-testid="dashboard-subtitle">
            {t.dashboard.subtitle}
          </p>
          <ul className="mt-8 space-y-4">
            {[t.dashboard.bullet_1, t.dashboard.bullet_2, t.dashboard.bullet_3].map((b, i) => (
              <li key={i} data-testid={`dashboard-bullet-${i}`} className="flex items-start gap-3 text-[#1A1A1A]">
                <span className="mt-1 h-5 w-5 rounded-full bg-[#1A1A1A] text-white flex items-center justify-center flex-shrink-0">
                  <Check size={12} />
                </span>
                <span className="text-base font-light">{b}</span>
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal className="lg:col-span-7" delay={200}>
          <div className="relative">
            <div
              aria-hidden
              className="absolute -inset-10 -z-10 blur-3xl opacity-50 animate-blob-slow"
              style={{
                background:
                  "radial-gradient(50% 50% at 30% 30%, rgba(167,139,250,0.45) 0%, transparent 70%), radial-gradient(50% 50% at 70% 70%, rgba(103,232,249,0.35) 0%, transparent 70%)",
              }}
            />
            <div className="relative rounded-3xl overflow-hidden border border-black/5 shadow-[0_40px_80px_-30px_rgba(0,0,0,0.25)] bg-white">
              <img
                src={ASSETS.dashboard}
                alt="AURA dashboard"
                data-testid="dashboard-image"
                className="w-full h-auto"
              />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
